import { FC, useState, useMemo } from 'react';
import { useLoaderData, LoaderFunctionArgs } from 'react-router-dom';
import styled from 'styled-components';

import SingleCardPpvYear from '../components/listppvbyyear_components/SingleCardPpvYear';
import CommonWrapper from '../components/ui_components/CommonComponentsStructureCss';
import SelectYear from '../components/ppv_components/SelectYear';
import type { PPVSpecific } from '../types';

const MainContainer = styled.div``;

const TopSize = styled.div`
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  padding: 5px;

  & h2.yearTitle {
    text-align: center;
    font-size: 30px;
  }
`;

const ListPpvContainer = styled.div`
  width: 100%;
`;

const PpvGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
`;

interface PPVByYearResponse {
  currentYear: string;
  listPpv: Record<string, PPVSpecific[]>;
}

const ListPpvByYear: FC = () => {
  const responseFromPrincipalApi = useLoaderData() as PPVByYearResponse;
  const [specificYear, setSpecificYear] = useState<string>(responseFromPrincipalApi.currentYear);
  const allPpvOfThisYear = useMemo<PPVSpecific[]>(
    () => responseFromPrincipalApi.listPpv[specificYear] ?? [],
    [specificYear, responseFromPrincipalApi.listPpv]
  );

  const handlerChangeYear = (year: string): void => {
    setSpecificYear(year);
  };

  return (
    <CommonWrapper>
      <MainContainer className="container">
        <TopSize className="row">
          <div className="col-4"></div>
          <h2 className="yearTitle col-4">{specificYear}</h2>
          <SelectYear onChangeYearYetSet={handlerChangeYear} />
        </TopSize>

        <ListPpvContainer>
          <PpvGrid>
            {allPpvOfThisYear.map((ppv, index) => (
              <SingleCardPpvYear
                key={'ppv-' + index + '-' + ppv.id}
                id={'ppv-' + index + '-' + ppv.id}
                idApi={ppv.id}
                image_path={ppv.img_path}
                namePpv={ppv.ppv_description?.name || ''}
                date={ppv.date}
              />
            ))}
          </PpvGrid>
        </ListPpvContainer>
      </MainContainer>
    </CommonWrapper>
  );
};

export default ListPpvByYear;

export async function loader({ params }: LoaderFunctionArgs): Promise<PPVByYearResponse> {
  const response = await fetch(
    process.env.REACT_APP_BACKEND_URL + 'api/ppv/list/year/' + params.yearSelected
  );
  if (!response.ok) {
    throw new Error('Failed to load PPV by year');
  }
  const resData = await response.json();
  return resData;
}
